import { useState, useEffect } from 'react'
import { TextInput, IconButton, Label, Text, InputCheckbox, BottomButton } from 'components'

import 'assets/style/pages/MO_01_02_03.scss'
import { formatNumberComma } from 'utils/format-util'
import { isEmptyString } from 'utils/common-util'
import useModal from 'hook/useModal'

export default function SearchFilter({ data, func }) {
  const { alertModal } = useModal()

  const filterType = [
    { id: 'menuCls', title: '메뉴구분', count: 0, isShow: data.menuCls ? true : false },
    { id: 'igrGrpCls', title: '재료구분', count: 0, isShow: data.igrGrpCls ? true : false },
    { id: 'prc', title: '단가(원)', count: 0, isShow: data.prc ? true : false },
    { id: 'recmTim', title: '추천시기', count: 0, isShow: data.recmTim ? true : false },
    { id: 'rcmmInfo', title: '추천정보', count: 0, isShow: data.rcmmInfo ? true : false },
    { id: 'menuRcip', title: '조리법', count: 0, isShow: data.menuRcip ? true : false },
  ]

  const [selectedType, setSelectedType] = useState('menuCls')

  const [selectFilters, setSelectFilters] = useState(data?.filters)
  const [prc1, setPrc1] = useState(data?.prc1)
  const [prc2, setPrc2] = useState(data?.prc2)
  //input number의 경우 0000 dispaly문제로 인하여 문자열 형태로 state세팅
  const [dispPrc1, setDispPrc1] = useState(data?.prc1 ? data?.prc1.toString() : '0')
  const [dispPrc2, setDispPrc2] = useState(data?.prc2 ? data?.prc2.toString() : '0')
  const [timer, setTimer] = useState(null)

  useEffect(() => {
    clearTimeout(timer)
    setTimer(
      setTimeout(() => {
        callbackFunc(selectFilters, prc1, prc2)
      }, 1000),
    )
  }, [selectFilters])

  useEffect(() => {
    if (prc2 >= prc1) {
      callbackFunc(selectFilters, prc1, prc2)
    }
  }, [prc1, prc2])

  useEffect(() => {
    clearTimeout(timer)
    setTimer(
      setTimeout(() => {
        setPrc1(Number(dispPrc1))
        setPrc2(Number(dispPrc2))
      }, 1000),
    )
  }, [dispPrc1, dispPrc2])

  const changeFilter = (flag, data) => {
    setSelectFilters((prev) => {
      let idx = -1
      for (let i = 0; i < prev.length; i++) {
        if (prev[i].filterType === data.filterType && prev[i].value === data.value) {
          idx = i
          break
        }
      }
      if (flag && idx === -1) {
        prev.push(data)
      } else {
        prev.splice(idx, 1)
      }
      return [...prev]
    })
  }

  const callbackFunc = (filters, prc1, prc2) => {
    func({
      filters: filters,
      prc1: Number(prc1),
      prc2: Number(prc2),
    })
  }

  //단가
  const setPrc = (type, gubun) => {
    let value = 0
    if (type === '1') {
      setDispPrc1((prev) => {
        let prevPrc = parseInt(prev)
        if (gubun === 'minus' && prevPrc > 0) {
          value = prevPrc - 100
        } else if (gubun === 'plus') {
          value = prevPrc + 100
        }
        if (value > parseInt(dispPrc2)) {
          alertModal('최저가는 최고가보다 클 수 없습니다.')
          value = prevPrc
        }
        return value.toString()
      })
    } else {
      setDispPrc2((prev) => {
        let prevPrc = parseInt(prev)
        if (gubun === 'minus' && prevPrc > 0) {
          value = prevPrc - 100
        } else if (gubun === 'plus') {
          value = prevPrc + 100
        }
        if (value < parseInt(dispPrc1)) {
          alertModal('최고가는 최저가보다 작을 수 없습니다.')
          value = prevPrc
        }
        return value.toString()
      })
    }
  }

  //메뉴구분변경
  const changeMenuCls = (e, data) => {
    changeFilter(e.target.checked, { ...data, filterType: 'menuCls' })
  }

  //재료구분변경
  const changeIgrGrpCls = (e, data) => {
    changeFilter(e.target.checked, { ...data, filterType: 'igrGrpCls' })
  }

  // 추천시기 변경
  const changeRecmTim = (e, data) => {
    changeFilter(e.target.checked, { ...data, filterType: 'recmTim' })
  }

  // 추천정보
  const changeRcmmInfo = (e, data) => {
    changeFilter(e.target.checked, { ...data, filterType: 'rcmmInfo' })
  }
  // 조리법 변경
  const changeMenuRcip = (e, data) => {
    changeFilter(e.target.checked, { ...data, filterType: 'menuRcip' })
  }

  return (
    <>
      <section className="site-all-menu-area" style={{ marginBottom: selectFilters.length > 0 ? '40px' : '' }}>
        <div className="left">
          <ul className="site-all-menu-1">
            {filterType.map((item, i) => {
              if (item.isShow) {
                return (
                  <li key={i}>
                    <Text
                      className={`title ${item.id === selectedType ? ' active' : ''}`}
                      onClick={() => {
                        setSelectedType(item.id)
                      }}
                    >
                      {item.title}
                    </Text>
                    {selectFilters.filter((data) => data.filterType === item.id).length > 0 && (
                      <Text className="result-count">
                        {selectFilters.filter((data) => data.filterType === item.id).length}
                      </Text>
                    )}
                  </li>
                )
              }
            })}
          </ul>
        </div>
        <div className="right">
          {/* 메뉴구분 */}
          <div className="y-scrollable flex-1" style={{ display: selectedType === 'menuCls' ? 'block' : 'none' }}>
            <ul className="checkbox-list">
              {data?.menuCls?.map((item, i) => (
                <li key={i}>
                  <InputCheckbox
                    value={item.commCd}
                    title={item.commCdNm}
                    onChangeObj={changeMenuCls}
                    checked={
                      selectFilters.filter((data) => data.filterType === 'menuCls' && data.value === item.commCd)
                        .length > 0
                        ? true
                        : false
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
          {/* 재료구분 */}
          <div className="y-scrollable flex-1" style={{ display: selectedType === 'igrGrpCls' ? 'block' : 'none' }}>
            <ul className="checkbox-list">
              {data?.igrGrpCls?.map((item, i) => (
                <li key={i}>
                  <InputCheckbox
                    value={item.commCd}
                    title={item.commCdNm}
                    onChangeObj={changeIgrGrpCls}
                    checked={
                      selectFilters.filter((data) => data.filterType === 'igrGrpCls' && data.value === item.commCd)
                        .length > 0
                        ? true
                        : false
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
          {/* 단가/원 */}
          <div className="y-scrollable flex-1" style={{ display: selectedType === 'prc' ? 'block' : 'none' }}>
            <ul className="price-range">
              <li>
                <Label level="3" text="최저가" />
                <div className="right">
                  <IconButton type="minus" border="true" size="40" onClick={() => setPrc('1', 'minus')} />
                  <TextInput
                    className={'hi_40'}
                    type={'number'}
                    inputType={'edit'}
                    placeholder="0"
                    value={dispPrc1}
                    onChange={(e) => {
                      let value = 0
                      if (!isEmptyString(e.target.value)) {
                        value = parseInt(e.target.value)
                      }
                      if (value > parseInt(dispPrc2)) {
                        alert('최저가는 최고가보다 클 수 없습니다.')
                      } else {
                        setDispPrc1(value.toString())
                      }
                    }}
                  />
                  <IconButton type="plus" border="true" size="40" onClick={() => setPrc('1', 'plus')} />
                </div>
              </li>
              <li>
                <Label level="3" text="최고가" />
                <div className="right">
                  <IconButton type="minus" border="true" size="40" onClick={() => setPrc('2', 'minus')} />
                  <TextInput
                    className={'hi_40'}
                    type={'number'}
                    inputType={'edit'}
                    placeholder="0"
                    value={dispPrc2}
                    onChange={(e) => {
                      let value = 0
                      if (!isEmptyString(e.target.value)) {
                        value = parseInt(e.target.value)
                      }

                      if (value < parseInt(dispPrc1)) {
                        alert('최고가는 최저가보다 작을 수 없습니다.')
                      } else {
                        setDispPrc2(value.toString())
                      }
                    }}
                  />
                  <IconButton type="plus" border="true" size="40" onClick={() => setPrc('2', 'plus')} />
                </div>
              </li>
            </ul>
          </div>
          {/* 추천시기 */}
          <div className="y-scrollable flex-1" style={{ display: selectedType === 'recmTim' ? 'block' : 'none' }}>
            <ul className="checkbox-list">
              {data?.recmTim?.map((item, i) => (
                <li key={i}>
                  <InputCheckbox
                    value={item.commCd}
                    title={item.commCdNm}
                    onChangeObj={changeRecmTim}
                    checked={
                      selectFilters.filter((data) => data.filterType === 'recmTim' && data.value === item.commCd)
                        .length > 0
                        ? true
                        : false
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
          {/* 추천정보 */}
          <div className="y-scrollable flex-1" style={{ display: selectedType === 'rcmmInfo' ? 'block' : 'none' }}>
            <ul className="checkbox-list">
              {data?.rcmmInfo?.map((item, i) => (
                <li key={i}>
                  <InputCheckbox
                    value={item.commCd}
                    title={item.commCdNm}
                    onChangeObj={changeRcmmInfo}
                    checked={
                      selectFilters.filter((data) => data.filterType === 'rcmmInfo' && data.value === item.commCd)
                        .length > 0
                        ? true
                        : false
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
          {/* 조리법 */}
          <div className="y-scrollable flex-1" style={{ display: selectedType === 'menuRcip' ? 'block' : 'none' }}>
            <ul className="checkbox-list">
              {data?.menuRcip?.map((item, i) => (
                <li key={i}>
                  <InputCheckbox
                    value={item.commCd}
                    title={item.commCdNm}
                    onChangeObj={changeMenuRcip}
                    checked={
                      selectFilters.filter((data) => data.filterType === 'menuRcip' && data.value === item.commCd)
                        .length > 0
                        ? true
                        : false
                    }
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section
        className="selected-list-area x-scrollable"
        style={{
          position: 'fixed',
          bottom: '0px',
          backgroundColor: 'white',
          display: selectFilters.length > 0 || prc2 > 0 ? 'block' : 'none',
        }}
      >
        <div className="btn-wrap">
          <button
            className="btn primary small"
            style={{ height: '30px' }}
            onClick={() => {
              setPrc1(0)
              setPrc2(0)
              setSelectFilters([])
              callbackFunc([], 0, 0)
            }}
          >
            초기화
          </button>
          {prc2 > 0 && (
            <button className="selected-item">
              {formatNumberComma(prc1)}~{formatNumberComma(prc2)}
              <span
                className="btn-remove"
                onClick={() => {
                  setPrc1(0)
                  setPrc2(0)
                }}
              />
            </button>
          )}
          {selectFilters.map((item, i) => (
            <button className="selected-item" key={i}>
              {item.title}
              <span className="btn-remove" onClick={() => changeFilter(false, item)} />
            </button>
          ))}
        </div>
      </section>
      {/* <BottomButton
        refresh={true}
        refreshOnClick={() => {
          alert()
        }}
        data={[
          // { text: "이미지등록" },
          { title: '검색', color: 'primary' },
        ]}
      /> */}
    </>
  )
}
